import { render, staticRenderFns } from "./AccountPackageForm.vue?vue&type=template&id=04c545e3"
import script from "./AccountPackageForm.vue?vue&type=script&lang=js"
export * from "./AccountPackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports